const removeSubmissionItem = function ({ commit }) {
  commit("CLEAR_SUBMISSION_ITEM");

  return Promise.resolve(undefined);
};

export default removeSubmissionItem;
